module.exports = __webpack_public_path__ + "img/esbati.b1e78165.jpg";